const apiUrl = process.env.REACT_APP_API_URL;
export const PutUsuariIdPermisProjecte = async ( id_professor : string,
                                                 id_projecte : string) => {

    try {
        const response =
                await fetch(`${apiUrl}:8061/usuaris/${id_professor}/permisos/projecte`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({id_professor, id_projecte})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
